import React from "react"
import { API, graphqlOperation } from "aws-amplify"
import { useSnackbar } from "notistack"
import { Link as RouterLink } from "react-router-dom"
import { useRecoilState } from "recoil"
import { makeStyles } from "@material-ui/core/styles"
import CircularProgress from "@material-ui/core/CircularProgress"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import EditIcon from "@material-ui/icons/Edit"
// import SendIcon from "@material-ui/icons/Send"
import ViewIcon from "@material-ui/icons/Visibility"

import DisclosureHeader from "./DisclosuresHeader"
import Layout from "../../components/AuthenticatedLayout"
import Button from "../../components/Button"
import Card from "../../components/Card"
import FormContainer from "../../components/FormContainer"
import { itemsByAssociationDate } from "../../graphqlCustom/queries"
import { onCreateDisclosure } from "../../graphqlCustom/subscriptions"
import { formatDate } from "../../libs/format"
import currentAssociation from "../../store/currentAssociation"

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(2),
  },
  date: {},
  title: {},
  unit: {
    fontWeight: "bold",
  },
}))

export default function Disclosures() {
  const [association] = useRecoilState(currentAssociation)
  const { enqueueSnackbar } = useSnackbar()
  const [items, setItems] = React.useState([])
  const [loaded, setLoaded] = React.useState(false)
  const classes = useStyles()

  React.useEffect(() => {
    async function fetchItems() {
      try {
        const { data } = await API.graphql(
          graphqlOperation(itemsByAssociationDate, {
            associationId: association.id,
            limit: 200,
            sortDirection: "DESC",
          })
        )
        if (data && data.itemsByAssociationDate.items.length) {
          setItems(data.itemsByAssociationDate.items)
        }
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar("Error fetching disclosures", {
          variant: "error",
        })
      } finally {
        setLoaded(true)
      }
    }
    if (association.id) {
      fetchItems()
      const subscription = API.graphql(graphqlOperation(onCreateDisclosure)).subscribe({
        next: (subscriptionItems) => {
          const { onCreateDisclosure: data } = subscriptionItems.value.data
          if (data) {
            setItems([...items, data])
          }
        },
      })
      return () => subscription.unsubscribe()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [association])

  return (
    <Layout title="Sale Disclosures">
      <DisclosureHeader showAddNew />
      <FormContainer fullWidth transparent wideContent>
        {items.length ? (
          items.map((item, index) => {
            return (
              <Card key={index}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={8}>
                    <Typography paragraph variant="h2" className={classes.title}>
                      <span className={classes.unit}>Unit: {item.unit}</span>,{" "}
                      <span className={classes.date}>
                        Prepared: {formatDate(item.preparedDate)}
                      </span>
                    </Typography>
                    <Typography variant="body2">
                      By: {item.preparedByName} on {formatDate(item.createdAt)}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    alignContent="flex-start"
                    justifyContent="flex-end"
                    item
                    xs={12}
                    md={4}
                  >
                    {!item.sent ? (
                      <Button
                        startIcon={<EditIcon />}
                        className={classes.button}
                        component={RouterLink}
                        to={`/0/sale/${item.id}/edit`}
                      >
                        Edit
                      </Button>
                    ) : (
                      ""
                    )}
                    <Button
                      startIcon={<ViewIcon />}
                      className={classes.button}
                      component={RouterLink}
                      to={`/0/sale/${item.id}`}
                    >
                      View
                    </Button>
                    {/* <Button endIcon={<SendIcon />} className={classes.button}>
                      Send
                    </Button> */}
                  </Grid>
                </Grid>
              </Card>
            )
          })
        ) : (
          <Grid container alignContent="center" justifyContent="center">
            {loaded ? <h3>No disclosures yet.</h3> : <CircularProgress />}
          </Grid>
        )}
      </FormContainer>
    </Layout>
  )
}
